import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Container, Row, Col, Card, CardBody, Alert, Form, Modal, Label, Input, Button, Table, UncontrolledTooltip } from "reactstrap";

import PropTypes from 'prop-types';
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import * as ur from 'helpers/url_helper';
import { Config, TOAST_OPTIONS } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";


import TreeMenu from 'react-simple-tree-menu';
import '../../../node_modules/react-simple-tree-menu/dist/main.css';

import FMap from 'pages/WQ/Maps/FMaps';




    const AssetMap = () => {
      
      toastr.options = TOAST_OPTIONS;
      const [points, setPoints] = useState([])
      const [pipes, setPipes] = useState([])
      const [facilities, setFacilities] = useState([])

      
      const fetchData = async () => {
          const data = {filter: ""}
          axios.post(ur.GEOCOORDINATES, JSON.stringify(data), Config).then((r)=>{ setPoints(r.data); }).catch((e)=>{ console.log(e)})
      };
      
      useEffect(() => {
       fetchData()
      },[]);
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Asset Map | {ur.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>
                        
                        
             
                        <Row>

                        
                        <Col lg={12}>
                          <Card>
                          <h5 className="card-header bg-transparent border-bottom text-uppercase">ASSET MAP</h5>
                                                         
                              <FMap points={points} pipes={pipes}/>
                            
                          </Card>
                        </Col>
                      </Row> 
                        
                           

                    </Container>
                </div>
            </>
        );
    }
    AssetMap.propTypes = {
      url: PropTypes.any
    };
export default AssetMap;